import AccountSettings from "../components/AccountSettings";

const Settings = () => {
  return (
    <div>
      <AccountSettings />
    </div>
  );
};

export default Settings;
